module.exports = __webpack_public_path__ + "img/image_3.126d6582.png";